module.exports = __webpack_public_path__ + "img/sprinkle-7.1b1695df.jpg";